import React, { FC } from "react";
import { ChevronUp, Filter } from "lucide-react";
import ButtonTertiary from "shared/Button/ButtonTertiary";

interface KitMobileFiltersProps {
    selectedType: string | undefined;
    selectedBudget: string | undefined;
    onOpenTypeModal: () => void;
    onOpenBudgetModal: () => void;
    onClear: () => void;
}

const KitMobileFilters: FC<KitMobileFiltersProps> = ({
    selectedType,
    selectedBudget,
    onOpenTypeModal,
    onOpenBudgetModal,
    onClear,
}) => {
    const isAnySelected = !!selectedType || !!selectedBudget;

    return (
        <div className="w-full border-b border-gray-200 bg-white px-4 shadow-sm sticky top-0 z-30 py-1 lg:hidden">
            <div className="flex items-center gap-3 overflow-x-auto no-scrollbar mt-5 pb-2">
                <div className="flex items-center gap-2 pr-4 border-r border-gray-300">
                    {/* Show Filter Icon if nothing selected, else show Clear button */}
                    {!isAnySelected && (
                        <Filter
                            size={18}
                            className="text-gray-700"
                        />
                    )}
                    {isAnySelected && (
                        <ButtonTertiary
                            onClick={onClear}
                            variant="cancel"
                            className="flex items-center gap-1"
                        >
                            <Filter size={18} />
                            Clear
                        </ButtonTertiary>
                    )}
                </div>

                {/* Category Pill */}
                <ButtonTertiary
                    onClick={onOpenTypeModal}
                    className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm whitespace-nowrap font-semibold transition-all duration-200 shadow-sm ${!!selectedType
                            ? "text-indigo-400 border-2 border-indigo-400"
                            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                        }`}
                >
                    <span className="flex items-center gap-1">
                        Category
                        {/* Show count badge if selected. Since we only single select, count is 1 or 0 */}
                        {!!selectedType && (
                            <span className="bg-indigo-500 text-white text-[10px] font-semibold px-2 rounded-full">
                                1
                            </span>
                        )}
                    </span>
                    <ChevronUp size={14} />
                </ButtonTertiary>

                {/* Budget Pill */}
                <ButtonTertiary
                    onClick={onOpenBudgetModal}
                    className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm whitespace-nowrap font-semibold transition-all duration-200 shadow-sm ${!!selectedBudget
                            ? "text-indigo-400 border-2 border-indigo-400"
                            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                        }`}
                >
                    <span className="flex items-center gap-1">
                        Budget
                        {!!selectedBudget && (
                            <span className="bg-indigo-500 text-white text-[10px] font-semibold px-2 rounded-full">
                                1
                            </span>
                        )}
                    </span>
                    <ChevronUp size={14} />
                </ButtonTertiary>
            </div>
        </div>
    );
};

export default KitMobileFilters;
